import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import Vue from 'vue'
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types'

//角色管理
const addRole = (params) => postAction('/api/sys/role/add', params)
//角色管理
const addZJK = (params) => postAction('/api/sysexpertlibraryallocation/add', params)
const editRole = (params) => putAction('/api/sys/role/edit', params)
const editZJK = (params) => postAction('/api/sysexpertlibraryallocation/edit', params)
// const getRoleList = (params)=>getAction("/api/sys/role/list",params);
// const deleteRole = (params)=>deleteAction("/api/sys/role/delete",params);
// const deleteRoleList = (params)=>deleteAction("/api/sys/role/deleteBatch",params);
const checkRoleCode = (params) => getAction('/api/sys/role/checkRoleCode', params)
const queryall = (params) => getAction('/api/sys/role/queryall', params)
const sysInfoall = (params) => getAction('/api/atlxsysinfo/listWithoutPage', params)
// 查询身份信息
const sfxx = (params) => getAction('/api/common/select/byType/UserRoleEnum', params)
//角色分配树状图
const queryIdTreeList = (params) => getAction('/api/sys/role/queryRoleTreeList', params)
const addWorkFlow = (params) => postAction('/api/sysuserworkflow/add', params)
// 登陆选择
//这里每一个都是一个接口  对应到java给你的接口里面
// addUser这个从字面意思来看就是一个添加用户的接口  editUser->编辑用户  对应到你的页面就是一个方法去添加或者编辑

// 文件上传
const FileUpload = (params) => postAction('/uploader/notChunkUploader', params)
//用户管理
const addUser = (params) => postAction('/api/sys/user/add', params)
const editUser = (params) => putAction('/api/sys/user/edit', params)
const queryUserRole = (params) => getAction('/api/sys/user/queryUserRole', params)
const getUserList = (params) => getAction('/api/sys/user/list', params)
// const deleteUser = (params)=>deleteAction("/api/sys/user/delete",params);
// const deleteUserList = (params)=>deleteAction("/api/sys/user/deleteBatch",params);
const frozenBatch = (params) => putAction('/api/sys/user/frozenBatch', params)
//冻结or解冻用户
const frozenUser = (params) => postAction('api/sys/user/updateStatus', params)
//验证用户是否存在
const checkOnlyUser = (params) => getAction('/api/sys/user/checkOnlyUser', params)
//改变密码
const changePassword = (params) => putAction('/api/sys/user/changePassword', params)
//权限管理
const addPermission = (params) => postAction('/api/sys/permission/add', params)
const editPermission = (params) => putAction('/api/sys/permission/edit', params)
const getPermissionList = (params) => getAction('/api/sys/permission/list', params)
const getRoleUserList = (params) => getAction('/api/sys/role/list', params)
/*update_begin author:wuxianquan date:20190908 for:添加查询一级菜单和子菜单查询api */
const getSystemMenuList = (params) => getAction('/api/sys/permission/getSystemMenuList', params)
const getSystemSubmenu = (params) => getAction('/api/sys/permission/getSystemSubmenu', params)
const getSystemSubmenuBatch = (params) => getAction('/api/sys/permission/getSystemSubmenuBatch', params)
/*update_end author:wuxianquan date:20190908 for:添加查询一级菜单和子菜单查询api */

// const deletePermission = (params)=>deleteAction("/api/sys/permission/delete",params);
// const deletePermissionList = (params)=>deleteAction("/api/sys/permission/deleteBatch",params);

const queryTreeList = (params) => getAction('/api/sys/permission/queryTreeList', params)
const queryTreeListByAppId = (params) => getAction('/api/sys/permission/queryTreeListByAppId', params)

// const queryTreeListForRole = (params) => getAction("/api/sys/role/queryTreeList", params);
const queryTreeListForRole = (params) => getAction('/api/sys/permission/list', params)
const userPermissionList = (params) => getAction('/api/sys/permission/userPermissionList', params)
const queryListAsync = (params) => getAction('/api/sys/permission/queryListAsync', params)
const queryRolePermission = (params) => getAction('/api/sys/permission/queryRolePermission', params)
const queryUserPermission = (params) => getAction('/api/sys/permission/queryUserPermission', params)
const saveRolePermission = (params) => postAction('/api/sys/permission/saveRolePermission', params)
const saveUserPermission = (params) => postAction('/api/sys/user/saveUserPermission', params)
//const queryPermissionsByUser = (params)=>getAction("/api/sys/permission/queryByUser",params);
const queryPermissionsByUser = (params) => getAction('/api/sys/permission/getUserPermissionByToken', params)
const loadAllRoleIds = (params) => getAction('/api/sys/permission/loadAllRoleIds', params)
const getPermissionRuleList = (params) => getAction('/api/sys/permission/getPermRuleListByPermId', params)
const queryPermissionRule = (params) => getAction('/api/sys/permission/queryPermissionRule', params)

// 部门管理
const queryDepartTreeList = (params) => getAction('/api/sys/sysDepart/queryTreeList', params)
const queryIdTree = (params) => getAction('/api/sys/sysDepart/queryIdTree', params)
const queryParentName = (params) => getAction('/api/sys/sysDepart/queryParentName', params)
const searchByKeywords = (params) => getAction('/api/sys/sysDepart/searchBy', params)
const deleteByDepartId = (params) => deleteAction('/api/sys/sysDepart/delete', params)

//二级部门管理
const queryDepartPermission = (params) => getAction('/api/sys/permission/queryDepartPermission', params)
const saveDepartPermission = (params) => postAction('/api/sys/permission/saveDepartPermission', params)
const queryTreeListForDeptRole = (params) => getAction('/api/sys/sysDepartPermission/queryTreeListForDeptRole', params)
const queryDeptRolePermission = (params) => getAction('/api/sys/sysDepartPermission/queryDeptRolePermission', params)
const saveDeptRolePermission = (params) => postAction('/api/sys/sysDepartPermission/saveDeptRolePermission', params)
const queryMyDepartTreeList = (params) => getAction('/api/sys/sysDepart/queryMyDeptTreeList', params)

//日志管理
//const getLogList = (params)=>getAction("/api/sys/log/list",params);
const deleteLog = (params) => deleteAction('/api/sys/log/delete', params)
const deleteLogList = (params) => deleteAction('/api/sys/log/deleteBatch', params)

//数据字典
const addDict = (params) => postAction('/api/sys/Dict/add', params)
const editDict = (params) => putAction('/api/sys/Dict/edit', params)
//const getDictList = (params)=>getAction("/api/sys/Dict/list",params);
const treeList = (params) => getAction('/api/sys/Dict/treeList', params)
// const delDict = (params)=>deleteAction("/api/sys/Dict/delete",params);
//const getDictItemList = (params)=>getAction("/api/sys/DictItem/list",params);
const addDictItem = (params) => postAction('/api/sys/DictItem/add', params)
const editDictItem = (params) => putAction('/api/sys/DictItem/edit', params)
//const delDictItem = (params)=>deleteAction("/api/sys/DictItem/delete",params);
//const delDictItemList = (params)=>deleteAction("/api/sys/DictItem/deleteBatch",params);

//枚举
export const ajaxGetEnumItems = (code, params) => getAction(`/api/common/select/byType/${code}`, params)
//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/api/sys/dict/getDictItems/${code}`, params)
//从缓存中获取字典配置
function getDictItemsFromCache(dictCode) {
  if (Vue.ls.get(UI_CACHE_DB_DICT_DATA) && Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]) {
    let dictItems = Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]
    console.log('-----------getDictItemsFromCache----------dictCode=' + dictCode + '---- dictItems=', dictItems)
    return dictItems
  }
}
//系统通告
const doReleaseData = (params) => getAction('/api/sys/annountCement/doReleaseData', params)
const doReovkeData = (params) => getAction('/api/sys/annountCement/doReovkeData', params)
//获取系统访问量
const getLoginfo = (params) => getAction('/api/sys/loginfo', params)
const getVisitInfo = (params) => getAction('/api/sys/visitInfo', params)
//数据日志访问
// const getDataLogList = (params)=>getAction("/api/sys/DataLog/list",params);

// 根据部门主键查询用户信息
const queryUserByDepId = (params) => getAction('/api/sys/user/queryUserByDepId', params)

// 查询用户角色表里的所有信息
const queryUserRoleMap = (params) => getAction('/api/sys/user/queryUserRoleMap', params)
// 重复校验
const duplicateCheck = (params) => getAction('/api/sys/duplicate/check', params)
// const duplicateCheck = (params) => getAction("/api/sys/Duplicate/check", params);
const checkRoleCodeByAppId = (params) => getAction('/api/sys/role/checkRoleCodeByAppId', params)

// 加载分类字典
const loadCategoryData = (params) => getAction('/api/sys/category/loadAllData', params)
const checkRuleByCode = (params) => getAction('/api/sys/checkRule/checkByCode', params)

//我的通告
const getUserNoticeInfo = (params) => getAction('/api/sys/sysAnnouncementSend/getMyAnnouncementSend', params)

/*++++++++++++++++++++++++++@ [履约信息]
------------------------------------------------------------------------------------------------------------------------ */
//--通过id查询
export const agreementInfoQueryById = (params) => getAction('api/agreementInfo/queryById', params)

//--通过id查询奖惩信息
export const rewardPunishmentInfoQueryById = (params) => getAction('api/rewardPunishmentInfo/queryById', params)

export {
  // imgView,
  // domian,
  sysInfoall,
  addRole,
  addZJK,
  editRole,
  editZJK,
  checkRoleCode,
  addUser,
  editUser,
  queryUserRole,
  getUserList,
  queryall,
  frozenBatch,
  checkOnlyUser,
  changePassword,
  getPermissionList,
  addPermission,
  editPermission,
  queryTreeList,
  queryListAsync,
  queryRolePermission,
  queryUserPermission,
  saveRolePermission,
  saveUserPermission,
  queryPermissionsByUser,
  loadAllRoleIds,
  getPermissionRuleList,
  queryPermissionRule,
  queryDepartTreeList,
  queryIdTree,
  queryParentName,
  searchByKeywords,
  deleteByDepartId,
  deleteLog,
  deleteLogList,
  addDict,
  editDict,
  treeList,
  addDictItem,
  editDictItem,
  doReleaseData,
  doReovkeData,
  getLoginfo,
  getVisitInfo,
  queryUserByDepId,
  queryUserRoleMap,
  duplicateCheck,
  queryTreeListForRole,
  userPermissionList,
  getSystemMenuList,
  getSystemSubmenu,
  getSystemSubmenuBatch,
  loadCategoryData,
  checkRuleByCode,
  queryDepartPermission,
  saveDepartPermission,
  queryTreeListForDeptRole,
  queryDeptRolePermission,
  saveDeptRolePermission,
  queryMyDepartTreeList,
  getUserNoticeInfo,
  getDictItemsFromCache,
  queryIdTreeList,
  FileUpload,
  sfxx,
  getRoleUserList,
  checkRoleCodeByAppId,
  queryTreeListByAppId,
  addWorkFlow,
  frozenUser
}
